import React, { forwardRef } from "react";
import { IColorPickerRgb } from "pages/secure/facility/websiteBuilder/editor/components/colorPicker/colorPickerHelpers";
import "./colorHandle.scss";

interface IColorHandleProps {
  x: number;
  y?: number;
  height: number;
  rgb: IColorPickerRgb;
  moving: boolean;
  onPointerDown: React.PointerEventHandler<HTMLDivElement>;
}

export const ColorHandle = forwardRef<HTMLDivElement, IColorHandleProps>((props, handleRef) => {
  const { x, y, height, rgb, moving, onPointerDown } = props;

  return (
    <div
      className="color-handle-outer-ring"
      style={{
        left: x,
        top: y,
        transform: `translate(-50%, ${y == null ? "0%" : "-50%"})`,
      }}
    >
      <div
        ref={handleRef}
        className="color-handle"
        style={{
          height: `${height}px`,
          cursor: moving ? "grabbing" : "grab",
          backgroundColor: `rgb(${rgb.r},${rgb.g},${rgb.b})`,
        }}
        onPointerDown={onPointerDown}
      />
    </div>
  );
});

ColorHandle.displayName = "ColorHandle";
